export default __webpack_public_path__ + "static/media/Moonlit ocean2.863d7949.jpg";